import * as React from "react";

interface IButtonGroupProps {
    children: React.ReactNode[] | React.ReactNode;
}

export function ButtonGroup({ children }: IButtonGroupProps) {
    return <div className="flex gap-4 items-center">{children}</div>;
}
